import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

export const CustomPinInput = ({
  pinLength = 4,
  pin,
  onPinChange,
  onPinComplete,
  disabled = false,
  autoFocus = false,
}) => {
  const [focusedIndex, setFocusedIndex] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only allow digits

    if (value.length <= pinLength) {
      onPinChange?.(value);

      // Check if PIN is complete
      if (value.length === pinLength) {
        onPinComplete?.(value);
      }
    }
  };

  const handleInputFocus = () => {
    setFocusedIndex(0);
  };

  const handleInputBlur = () => {
    setFocusedIndex(null);
  };

  const handleBoxClick = (index) => {
    setFocusedIndex(index);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="relative">
      {/* Hidden input for capturing keyboard input */}
      <input
        ref={inputRef}
        type="number"
        inputMode="numeric"
        pattern="[0-9]*"
        value={pin}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        disabled={disabled}
        className="absolute inset-0 w-full h-full opacity-0 cursor-default"
        style={{
          caretColor: "transparent",
          fontSize: "16px", // Prevents zoom on iOS
        }}
        maxLength={pinLength}
      />

      {/* Visual PIN display */}
      <div className="flex gap-2.5">
        {Array.from({ length: pinLength }).map((_, index) => (
          <div
            key={index}
            onClick={() => !disabled && handleBoxClick(index)}
            className={clsx(
              "flex-1 w-full h-12 border rounded-md flex items-center justify-center bg-white cursor-pointer transition-colors",
              focusedIndex !== null &&
                index === Math.min(pin.length, pinLength - 1)
                ? "border-blue-500 border-2"
                : "border-[#DDDDDD]",
              disabled && "bg-gray-100 cursor-not-allowed"
            )}
          >
            <span className="text-xl font-semibold text-[#757575]">
              {index < pin.length ? "*" : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
